var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHorizontal = function SvgHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 112 72"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 8,
    x: 5,
    y: 4,
    className: "horizontal_svg__svg-slate-200",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 17,
    x: 5,
    y: 16,
    className: "horizontal_svg__svg-slate-200",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 17,
    x: 48,
    y: 16,
    className: "horizontal_svg__svg-slate-200",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 23,
    x: 5,
    y: 37,
    className: "horizontal_svg__svg-slate-200",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 4,
    x: 5,
    y: 64,
    className: "horizontal_svg__svg-slate-200",
    rx: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 8,
    r: 2,
    className: "horizontal_svg__svg-slate-300"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 8,
    r: 2,
    className: "horizontal_svg__svg-slate-300"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 8,
    r: 2,
    className: "horizontal_svg__svg-slate-300"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 8,
    r: 2,
    className: "horizontal_svg__svg-slate-300"
  })));
};
export default SvgHorizontal;